<div class="po-row" [formGroup]="projectItemForm">
  <div class="po-radio">
    <input class="with-gap" type="radio" name="primary"
      [value]="projectItemForm.controls.id.value"
      [checked]="currentItem == projectItemForm.controls.id.value"
      [attr.disabled]="readOnly ? '' : null"
      (change)="onItemSelectionChange(projectItemForm)"
      id="{{ 'primary' + current }}">
    <label attr.for="{{ 'primary' + current }}" matTooltip="mark as primary production office" matTooltipPosition="above"></label>
  </div>
  <div class="po-fields">
    <mat-form-field appearance="fill">
      <mat-label>Production Entity</mat-label>
      <input matInput formControlName="entity" type="text" maxlength="100">
    </mat-form-field>
    <mat-form-field appearance="fill">
      <mat-label>Production Address</mat-label>
      <input matInput formControlName="address" type="text" maxlength="100">
    </mat-form-field>
    <div class="po-phone-row">
      <mat-form-field appearance="fill" class="po-phone-field">
        <mat-label>Production Phone number</mat-label>
        <input matInput formControlName="phoneNumber" type="tel" maxlength="20">
      </mat-form-field>
      <div class="po-actions" *ngIf="!readOnly">
        <button mat-icon-button *ngIf="current + 1 == count; else elseBlock"
          (click)="addProjectItem()" matTooltip="add another production office" matTooltipPosition="below">
          <mat-icon>add</mat-icon>
        </button>
        <ng-template #elseBlock>
          <button mat-icon-button (click)="removeProjectItem(current)"
            matTooltip="remove production office" matTooltipPosition="below">
            <mat-icon>remove</mat-icon>
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
